import React from 'react'
import { type GridColumns, GridList, withContainerSize } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { ErrorPage } from 'gin-and-tonic/containers/error-page/ErrorPage'
import { type useSearchCollections } from 'domains/collections/api/searchCollections.hooks'
import { type CollectionDatum } from 'domains/collections/types/collections.types'
import { type useSearchChildCollectionCandidates } from 'domains/collections/api/searchChildCollectionCandidates.hook'
import { type useGetCollectionQuery } from 'domains/collections/api'

interface CollectionsListProps
  extends Pick<
    ReturnType<typeof useSearchCollections>,
    'apiLoading' | 'apiError' | 'canLoadMore' | 'loadMore'
  > {
  columns: GridColumns<CollectionDatum>
  collections:
    | ReturnType<typeof useSearchCollections>['collections']
    | ReturnType<typeof useGetCollectionQuery>['data']['collection']['children']
    | ReturnType<typeof useSearchChildCollectionCandidates>['collections']
  refetch:
    | ReturnType<typeof useSearchCollections>['refetch']
    | ReturnType<typeof useSearchChildCollectionCandidates>['refetch']
}

const ExpandableGrid = withContainerSize(GridList)

export const CollectionsList: React.FunctionComponent<CollectionsListProps> = ({
  columns,
  collections,
  apiLoading,
  apiError,
  canLoadMore,
  loadMore,
  refetch,
}) => {
  const noResults = useDomainMessage('collectionsDomain.noResults')

  if (apiError) {
    return <ErrorPage action={refetch} />
  }

  return (
    <ExpandableGrid
      columns={columns}
      data={collections}
      onLoadMore={loadMore}
      canLoadMore={canLoadMore}
      loadingMore={apiLoading}
      emptyStateMessage={noResults}
    />
  )
}
